import { ReactNode, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { getAppConfig } from '@config/get-app-config';
import { REALM } from '@utilities/constants';

const PageThemeContainer = ({ children }: { children: ReactNode }) => {
  const {
    site: { realm = REALM.ZOOPLUS },
  } = getAppConfig();

  useEffect(() => {
    import(`../../../styles/${realm}-fonts.css`);
  }, [realm]);

  return (
    <>
      <Helmet>
        <body className={`z-brand-theme-2024-${realm}`} />
      </Helmet>
      {children}
    </>
  );
};

export default PageThemeContainer;
